export default {"src":"/_next/static/media/meet-atlas.dfba69d4.svg","height":64,"width":65};